import servicesUtils from '../utils/service'

export const assessmentServices = {
    async getAssessmentResultList(homeworkId, query) {
        try {
            const url = `${servicesUtils.resourceUrl('getAssessmentResultList')}`
                .replace(':diaryHomeworkId', homeworkId)
                + '?'
                + servicesUtils.queryParams(query);
            const res = await servicesUtils.get(url);
            return res.data;
        } catch (err) {
            console.log(`failed in getAssessmentResultList, err: ${err}`)
            throw err
        }
    },
    async getAssessmentResult(homeworkId, uuid) {
        try {
            const url = `${servicesUtils.resourceUrl('getAssessmentResult')}`
                .replace(':diaryHomeworkId', homeworkId)
                .replace(':uuid', uuid);
            const res = await servicesUtils.get(url);
            return res.data;
        } catch (err) {
            console.log(`failed in getAssessmentResult, err: ${err}`)
            throw err
        }
    },
    async getAssessmentResultDownload(homeworkId) {
        try {
            const url = `${servicesUtils.resourceUrl('getAssessmentResultDownload')}`
                .replace(':diaryHomeworkId', homeworkId);
            const res = await fetch(url, {
                method: 'get',
                responseType: 'blob',
                credentials: 'include'
            });
            return res;
        } catch (err) {
            console.log(`failed in getAssessmentResultDownload, err: ${err}`)
            throw err
        }
    },
}